var i = (o, r, t) => new Promise((a, c) => {
  var n = (e) => {
    try {
      p(t.next(e));
    } catch (s) {
      c(s);
    }
  }, f = (e) => {
    try {
      p(t.throw(e));
    } catch (s) {
      c(s);
    }
  }, p = (e) => e.done ? a(e.value) : Promise.resolve(e.value).then(n, f);
  p((t = t.apply(o, r)).next());
});
import { selfAxios as l } from "@oppein/op-utils";
function k(o) {
  return i(this, null, function* () {
    const {
      data: r
    } = yield l.post(
      "/designordercenter/productionOrder/specialApply/createBaseSelfPickup",
      o
    );
    return r == null ? void 0 : r.data;
  });
}
export {
  k as postCreateBaseSelfPickup
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/specialApply/createBaseSelfPickup/post.js
// module id = 1773
// module chunks = 41